import { render } from "./Stories.vue?vue&type=template&id=012ca816&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"

import "./Stories.vue?vue&type=style&index=0&id=012ca816&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-012ca816"

export default script